import en from "./en.json";
import th from "./th.json";

const STORAGE_KEY = "_sandee_language";
const DEFAULT_LANGUAGE = "th";

let savedLanguage = localStorage.getItem(STORAGE_KEY);

if (!savedLanguage) {
  savedLanguage = DEFAULT_LANGUAGE;
  localStorage.setItem(STORAGE_KEY, DEFAULT_LANGUAGE);
}

let currentLanguage = savedLanguage;

const resources = { en, th };

export function setLanguage(lang) {
  if (resources[lang]) {
    currentLanguage = lang;
    localStorage.setItem(STORAGE_KEY, lang);
  } else {
    console.warn(`Language "${lang}" is not supported. Falling back to '${DEFAULT_LANGUAGE}'.`);
    currentLanguage = DEFAULT_LANGUAGE;
    localStorage.setItem(STORAGE_KEY, DEFAULT_LANGUAGE);
  }
}

export function getLanguage() {
  return currentLanguage;
}

export function getText(key) {
  const translation = resources[currentLanguage][key];
  return translation !== undefined ? translation : "Undefined";
}

export function logInfo(message, data) {
  console.info(`[INFO] ${message}`, data || "");
}

export function logError(message, error) {
  console.error(`[ERROR] ${message}`, error);
}

export function isValidRedirectPath(path) {
  return typeof path === "string" && path.startsWith("/") && !path.startsWith("//");
}
